module.exports = __webpack_public_path__ + "static/media/login__image.f54fc829.svg";